import * as React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../components/Button";
import { getSx } from "./style";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "400px",
    padding: "30px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 24px)",
      margin: "12px",
      padding: "20px 12px",
    },
  },
  "& .MuiPaper-root": { maxWidth: "400px" },
  "& .MuiDialogActions-root": {},
}));

export default function Modal({
  open,
  subTitle,
  resolveButton,
  image,
  rejectButton,
  subText,
  successButton,
}) {
  const classes = getSx(successButton);

  return (
    <CustomDialog
      open={open}
      keepMounted
      TransitionComponent={Transition}
      sx={{ "& .MuiPaper-root": { maxWidth: "400px" } }}
    >
      <DialogContent sx={{ padding: "8px 20px" }}>
        <Box sx={classes.subTitleContainer}>
          {image && (
            <img
              src={image}
              alt="smile-logo"
              style={{ marginBottom: "10px", height: "150px" }}
            />
          )}
          {subTitle && (
            <Typography variant="h4" sx={classes.subTitle}>
              {subTitle}
            </Typography>
          )}
          {subText && (
            <Typography variant="h6" sx={classes.subText}>
              {subText}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions
        disableSpacing={false}
        sx={
          resolveButton.label === "Yes"
            ? classes.buttonWrapper
            : { ...classes.buttonWrapper, justifyContent: "center" }
        }
      >
        <Button sx={classes.button} {...resolveButton} />
        {resolveButton.label === "Yes" ? (
          <Button
            sx={{ ...classes.button, ...classes.cancelButton }}
            {...rejectButton}
          />
        ) : (
          ""
        )}
      </DialogActions>
    </CustomDialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  resolveButton: PropTypes.object,
  rejectButton: PropTypes.object,
  subText: PropTypes.string,
  successButton: PropTypes.bool,
};

Modal.defaultProps = {
  resolveButton: {},
  rejectButton: {},
};
